import i18next from "i18next";

import { GraphQLClient, gql } from "graphql-request";
import { getApiUrl } from "../../../lib/common/getApiUrl";

const apiUrl = getApiUrl();

const CLIENT_TOKEN =
  process.env.NODE_ENV === "development"
    ? process.env.API_CLIENT_TOKEN
    : window.location.pathname.split("/")[2];

const client = new GraphQLClient(`${apiUrl}/graphql`, {
  headers: () => ({
    "Client-Token": CLIENT_TOKEN as string,
    "Accept-Language": i18next.language,
  }),
});

export { gql, client };
